<template>
  <div v-if="infos && infos.sections" :class="{'edit-bg': $route.name === 'BodyEdit'}">
    <app-bar-edit v-if="$route.name === 'BodyEdit'" class="appBarEdit" />
    <nav-bar-edit v-if="navbar.open && $route.name === 'BodyEdit'"/>

    <div :class="{'ma-5': $route.name === 'BodyEdit', 'mobile-width': editViewType === 'mobile'}">
      <div :class="[{'device-view ma-5': editViewType === 'mobile'}]">
        <div v-for="(item, i) in infos.sections" :key="i" class="white">
          <div v-if="item.pageId === selectedPage || ['menu', 'footer'].includes(item.type)">
            <section-container v-if="item.type === 'menu'" :sectionId="item.id">
              <app-bar :id="item.id" :settings="item" class="appBar" @handleScrollTo="handleScrollTo"/>
            </section-container>

            <section-container v-if="item.type === 'cover'" :sectionId="item.id">
              <cover class="elevate" :id="item.id" :settings="item" @handleScrollTo="handleScrollTo"/>
            </section-container>

            <section-container v-if="item.type === 'title'" :sectionId="item.id">
              <title-component :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'content'" :sectionId="item.id">
              <about :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'speakers'" :sectionId="item.id">
              <speakers :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'materials'" :sectionId="item.id">
              <materials :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'campaign'" :sectionId="item.id">
              <Campaign :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'sponsors'" :sectionId="item.id">
              <sponsors :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'logos'" :sectionId="item.id">
              <logos :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'gallery'" :sectionId="item.id">
              <gallery :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'numbers'" :sectionId="item.id">
              <numbers :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'schedule'" :sectionId="item.id">
              <lecture :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'tickets'" :sectionId="item.id">
              <tickets :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'testimonials'" :sectionId="item.id">
              <testimonials :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'newsletter'" :sectionId="item.id">
              <newsletter :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'personalizedFaq'" :sectionId="item.id">
              <personalized-faq :id="item.id" :settings="item"/>
            </section-container>

            <section-container v-if="item.type === 'contact'" :sectionId="item.id">
              <contact :id="item.id" :settings="item" />
            </section-container>

            <section-container v-if="item.type === 'footer'" :sectionId="item.id">
              <footerComponent :id="item.id" :settings="item"/>
            </section-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SectionContainer from "../components/_v2/utils/SectionContainer";
import AppBarEdit from "../components/edit/AppBarEdit";
import About from "../components/about/About.vue";
import Cover from "../components/cover/Cover";
import Speakers from "../components/speakers/Speakers.vue";
import TitleComponent from "../components/title/TitleComponent.vue";
import Lecture from "../components/lecture/Lecture";
import Tickets from "../components/tickets/Tickets.vue";
import Gallery from "../components/gallery/Gallery.vue";
import Logos from "../components/logos/Logos.vue";
import Faq from "../components/faq/Faq.vue";
import Numbers from "../components/numbers/Numbers.vue";
import Contact from "../components/contact/Contact.vue";
import Newsletter from "../components/newsletter/Newsletter.vue";
import Testimonials from "../components/testimonials/Testimonials.vue";
import FooterComponent from "../components/footer/Footer.vue";
import AppBar from "../components/appBar/AppBar.vue";
import NavBarEdit from "../components/edit/NavBarEdit.vue";
import Campaign from "../components/campaign/Campaign.vue";
import Materials from "../components/materials/Materials.vue";
import Sponsors from "../components/sponsors/Sponsors.vue";
import PersonalizedFaq from "../components/faq/personalizedFaq.vue";

export default {
  name: "Body",
  components: {
    SectionContainer,
    Cover,
    TitleComponent,
    About,
    Speakers,
    Lecture,
    Tickets,
    Gallery,
    Logos,
    Faq,
    Numbers,
    Contact,
    Newsletter,
    Testimonials,
    FooterComponent,
    AppBar,
    NavBarEdit,
    AppBarEdit,
    Campaign,
    Materials,
    Sponsors,
    PersonalizedFaq,
  },

  computed: {
    ...mapGetters(["infos", "navbar", "editViewType", "hotsiteSelectedVersion", "selectedPage"]),
  },

  data: () => ({}),

  created() {
    if (this.$route.name === "BodyEdit") this.$store.dispatch("setNav", { open: true, sectionId: "" });
  },

  methods: {
    handleScrollTo(element) {
      document.getElementById(element.split("#")[1]).scrollIntoView(false);
    },

    firstRenderPageVerification () {
      const mainPage = this.infos.pages.find(page => page.route === '/')
      if (mainPage) this.$store.dispatch('setSelectedPage', mainPage.id)

      if (this.$route.name === 'CustomBodyPage') {
        const params = this.$route.params
        if (params.page) {
          const page = this.infos.pages.find(page => {
            return page.route.split('/')[1] === params.page 
          })

          if (page) {
            this.$store.dispatch('setSelectedPage', page.id)
          }
          else { 
            console.log('Página não encontrada, redirecionando para principal...')
            this.$router.push({name: 'CustomBodyPage', params: {...params, page: null}})
          }
        }
      }
    }    
  },  

  watch: {
    '$vuetify.breakpoint.width'(value) {
      if (this.$route.name === "BodyEdit") {
        if (value < 800) {
          this.$store.dispatch("setNav", { open: false, sectionId: this.navbar.sectionId })
          this.$store.dispatch('setEditViewType', 'mobile')
        } else { 
          this.$store.dispatch("setNav", { open: true, sectionId: this.navbar.sectionId })
          this.$store.dispatch('setEditViewType', 'desktop')
        }
      }
    },

    hotsiteSelectedVersion: {
      deep: true,
      handler (version, oldVersion) {
        if (oldVersion) console.log('Mudou para versão:', version, '/ Versão anterior:', oldVersion)
      } 
    },

    '$route.fullPath'(value, old) {
      const useBackBtnFromNavigator = value && old
      if (useBackBtnFromNavigator && this.$route.name !== "BodyEdit") {
        const params = this.$route.params
        if (params.page) {
          const page = this.infos.pages.find(page => {
            return page.route.split('/')[1] === params.page 
          })

          if (page) this.$store.dispatch('setSelectedPage', page.id)
        } else {
          const mainPage = this.infos.pages.find(page => page.route === '/')
          if (mainPage) this.$store.dispatch('setSelectedPage', mainPage.id)
        }
      }
    },

    infos: {
      deep: true,
      handler (value, oldValue) {
        if (oldValue === null) {
          this.firstRenderPageVerification()
        }
      }
    }
  }
};
</script>

<style scoped>
.appBar {
  z-index: 2;
}
.appBarEdit {
  z-index: 3;
}
.elevate {
  z-index: 0;
}

.mobile-width {
  display: flex;
  justify-content: center;
}

.device-view {
  width: 430px;
  height: 800px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
